import React, { useState } from "react";
import { Row, Col, Card, Input, Divider, Button, Select } from "antd";

import TextInput from "../input/TextInput";
import styled from "styled-components";
import { BsFolder } from "react-icons/all";
import { useSelector, useDispatch } from "react-redux";
import CustomModal from "../modals/customModal";
import { CatalogAction } from "../../store/actions";
import { useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
const { Option } = Select;
const CardWrapper = styled(Card)`
  min-height: 400px;
`;

const arr = [];
const { TextArea } = Input;
function General_Info() {
  let [isOpenModal, setIsOpenModal] = useState(false);
  let [isAdditiveModal, setIsAdditiveModal] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const categories = useSelector((store) => store?.CatalogReducer?.categories);

  const dispatch = useDispatch();
  const history = useHistory();

  const basemixData = useSelector(
    (store) => store?.CatalogReducer?.basemixData
  );
  const additivesData = useSelector(
    (store) => store?.CatalogReducer?.additives
  );
  const dataInBasemix = useSelector(
    (store) => store?.CatalogReducer?.basemixes
  );

  const [category, setCategory] = useState([]);
  const [basemix, setBasemix] = useState([]);
  const [additives, setAdditives] = useState([]);
  const [basemixDeatil, setBasemixDetail] = useState({});
  const [addBasemix, setAddBasemix] = useState({
    name: "",
    basemix_category_id: "",
  });
  const [addAdditive, setAddAdditive] = useState({ name: "" });
  const [customProduct, setCustomProduct] = useState({
    status: "",
    unit: "",
    name: "",
  });
  const [customError, setError] = useState({
    nameError: "",
    category_idError: "",
    basemix_idError: "",
  });
  const [basemixError, setBasemixErr] = useState({
    nameError: "",
    basemix_category_idError: "",
  });
  const [additiveError, setAdditiveError] = useState({
    nameError: "",
  });
  if (!arr.length) {
    const abc = basemixData.forEach((item) => {
      item.basemixes.map((v) => {
        arr.push({ name: v.name, id: v.id });
      });
    });
  }

  const postCustomProductData = (customProduct) => {
    const err = { ...customError };
    if (
      !customProduct.name.trim().length ||
      !customProduct.basemix_id ||
      !customProduct.category_id
    ) {
      if (!customProduct.name.trim().length) {
        err.nameError = "Product name is required.";
      }
      if (!customProduct.category_id) {
        err.category_idError = "Category name is required..";
      }
      if (!customProduct.basemix_id) {
        err.basemix_idError = "Product basemix is required.";
      }
      setError(err);
      return;
    }
    dispatch(
      CatalogAction.postCustomProductReq(customProduct, () =>
        history.push("/catalog")
      )
    );
  };
  const addBasemixHandler = () => {
    const err = { ...basemixError };
    if (!addBasemix?.name?.trim().length || !addBasemix.basemix_category_id) {
      if (!addBasemix?.name?.trim().length) {
        err.nameError = "Basemix name is required.";
      }
      if (!addBasemix.basemix_category_id) {
        err.basemix_category_idError = "Basemix category is required.";
      }
      setBasemixErr(err);
      return;
    }
    dispatch(
      CatalogAction.postBasemixReq(addBasemix, "basemix", () => {
        setAddBasemix({
          name: "",
          alias: "",
          description: "",
          category_id: "",
        });
        setIsOpenModal(false);
      })
    );
  };

  const addAdditiveHandler = () => {
    const err = { ...additiveError };
    if (!addAdditive.name?.trim().length) {
      if (!addAdditive?.name?.trim().length) {
        err.nameError = "Additive name is required.";
      }

      setAdditiveError(err);
      return;
    }
    dispatch(
      CatalogAction.postBasemixReq(addAdditive, "additive", () => {
        setAddAdditive({
          name: "",
          alias: "",
          description: "",
          // category_id:""
        });
        setIsAdditiveModal(false);
      })
    );
  };
  let inputRef;
  return (
    <CardWrapper>
      <h1 className="text-left" style={{ fontWeight: "bolder" }}>
        General Information
      </h1>
      <Row gutter={[20, 10]}>
        <Col xl={6} md={24} lg={6} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={9} xs={11} sm={11} md={4} lg={10}>
              <label className="text-left" style={{ fontSize: "12px" }}>
                Product Name{" "}
                <span style={{ color: "orange", fontSize: "10px" }}>*</span>
              </label>
            </Col>
            <Col xl={24} xs={24}>
              <Input
                onChange={(e) => {
                  setCustomProduct({
                    ...customProduct,
                    name: e.target.value,
                  });
                  setError({
                    ...customError,
                    nameError: "",
                  });
                }}
              />
              <Row justify="start">
                <Col>
                  <span className="danger-color text-left">
                    {customError.nameError && customError.nameError}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Col />
        </Col>
        <Col xl={6} md={24} lg={6} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={8} xs={9} sm={9} md={4} lg={10}>
              <label className="text-left" style={{ fontSize: "12px" }}>
                Product Sku
              </label>
            </Col>
            <Col xl={24} xs={24}>
              <Input
                onChange={(e) => {
                  setCustomProduct({
                    ...customProduct,
                    sku: e.target.value,
                  });
                }}
              />
            </Col>
          </Row>
          <Col />
        </Col>
        <Col xl={6} md={24} lg={6} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={4} xs={4} sm={9} md={2} lg={10}>
              <label className="text-left" style={{ fontSize: "12px" }}>
                Weight
              </label>
            </Col>
            <Col xl={24} xs={24}>
              <Input
                onChange={(e) =>
                  setCustomProduct({
                    ...customProduct,
                    weight: e.target.value,
                  })
                }
              />
            </Col>
          </Row>
          <Col />
        </Col>
        <Col xl={6} md={24} lg={6} xs={24}>
          <Row align="middle" justify="start">
            <Col xl={12} sm={12} md={5} lg={12}>
              <label className="text-left" style={{ fontSize: "12px" }}>
                Product Categories{" "}
                <span style={{ color: "orange", fontSize: "9px" }}>*</span>
              </label>
            </Col>
            <Col xl={24} xs={24}>
              <Select
                style={{ width: "100%", textAlign: "left" }}
                onChange={(e) => {
                  setCustomProduct({
                    ...customProduct,
                    category_id: e,
                  });
                  setError({
                    ...customError,
                    category_idError: "",
                  });
                }}
                placeholder="Select Product Categories"
              >
                {categories.map((productName) => {
                  return (
                    <Option key={productName.id} value={productName.id}>
                      {productName.name}
                    </Option>
                  );
                })}
              </Select>
              <Row justify="start">
                <Col>
                  <span className="danger-color text-right">
                    {customError.category_idError &&
                      customError.category_idError}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Col />
        </Col>
        <Col xl={3} sm={12} md={6} lg={12}>
          <label className="text-left" style={{ fontSize: "12px" }}>
            Product Description
          </label>
        </Col>
        <Col xl={24} xs={24} md={24}>
          <TextArea
            autoSize={{ minRows: 3, maxRows: 5 }}
            onChange={(e) =>
              setCustomProduct({
                ...customProduct,
                description: e.target.value,
              })
            }
          />
        </Col>
        <Col xl={24}>
          <Divider />
        </Col>
        <Col span={20}>
          <Row>
            <Col xl={10} sm={14} xs={12} md={12}>
              <h1 className="text-left" style={{ fontWeight: "bolder" }}>
                Product Basemix <span style={{ color: "orange" }}>*</span>
              </h1>
            </Col>
            <Col xl={12} sm={10} xs={12} md={12}>
              <h1 style={{ fontWeight: "bolder" }}>Additives</h1>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify="space-around" gutter={[50, 0]}>
            <Col xl={12} sm={12} xs={12} md={12}>
              <Select
                style={{ width: "100%", textAlign: "left" }}
                onChange={(e) => {
                  setCustomProduct({
                    ...customProduct,
                    basemix_id: e,
                  });
                  setError({
                    ...customError,
                    basemix_idError: "",
                  });
                }}
                placeholder="Select Product Basemix"
              >
                {dataInBasemix.map((item) => {
                  return (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
              <Row justify="start">
                <Col>
                  <span className="danger-color text-right">
                    {customError.basemix_idError && customError.basemix_idError}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col xl={12} sm={12} xs={12} md={12} className="pointer-cursor">
              <Select
                mode="multiple"
                className="pointer-cursor"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(e) =>
                  setCustomProduct({
                    ...customProduct,
                    product_additive: e,
                  })
                }
                placeholder="Select Product Additives"
              >
                {additivesData.map((data) => {
                  return (
                    <Option
                      key={data.id}
                      value={data.id}
                      className="pointer-cursor"
                    >
                      {data.name}
                    </Option>
                  );
                })}
              </Select>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify="space-between">
            <Col xl={4} sm={10} xs={12} md={12}>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                  width: "100%",
                  fontSize: "10px",
                }}
                onClick={() => {
                  setIsOpenModal(true);
                  setBasemixErr({
                    nameError: "",
                    basemix_category_idError: "",
                  });
                }}
              >
                ADD NEW BASEMIX
              </Button>
            </Col>
            <Col xl={4} sm={10} xs={12} md={12}>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                  width: "100%",
                  fontSize: "10px",
                }}
                onClick={() => {
                  setIsAdditiveModal(true);
                  setAdditiveError({
                    nameError: "",
                  });
                }}
              >
                ADD NEW ADDITIVE
              </Button>
            </Col>
          </Row>
        </Col>
        <Col xl={6} sm={24} xs={24} gutter={[0, 20]}>
          <Row>
            <Col
              xl={14}
              xs={12}
              sm={12}
              style={{
                border: "solid 1px ",
                padding: imageUrl ? "0rem" : "2rem",
              }}
            >
              {imageUrl ? (
                <img
                  width="120"
                  height="100"
                  src={imageUrl}
                  style={{ objectFit: "contain" }}
                />
              ) : (
                <BsFolder size="40" color="grey" />
              )}
            </Col>
            <Col xl={10} sm={10} xs={12}>
              <p>IMAGE SIZE: 150X150</p>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                }}
                onClick={() => inputRef.click()}
              >
                Add Image
              </Button>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify="end">
            <Col xl={4} sm={12} xs={12}>
              <Button
                style={{
                  backgroundColor: "#f57c00 ",
                  color: "#fff",
                  width: "100%",
                }}
                onClick={() => postCustomProductData(customProduct)}
              >
                Save
              </Button>
            </Col>
          </Row>

          <CustomModal
            visible={isOpenModal}
            onCancelModal={() => setIsOpenModal(false)}
            footer={[
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                // onClick={() => postBasemix(addBasemix)}
                onClick={addBasemixHandler}
              >
                Save
              </Button>,
            ]}
          >
            <Col xl={24}>
              <h5 className="text-left ">New Basemix</h5>
              <Divider />
            </Col>
            <Col xl={24} className="pointer-cursor">
              <Row justify="center" gutter={[10, 0]}>
                <Col xl={12}>
                  <TextInput
                    label="Basemix Name"
                    name="name"
                    onChange={(name) => {
                      setAddBasemix({
                        ...addBasemix,
                        name: name.target.value,
                      });
                      setBasemixErr({
                        ...basemixError,
                        nameError: "",
                      });
                    }}
                    value={addBasemix.name}
                    // value={userDetail.first_name}
                    required
                  />
                  <Row justify="start">
                    <Col>
                      <span className="danger-color text-left">
                        {basemixError.nameError && basemixError.nameError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col xl={12}>
                  <TextInput
                    label="Basemix Alias"
                    name="alias"
                    onChange={(alias) =>
                      setAddBasemix({
                        ...addBasemix,
                        alias: alias.target.value,
                      })
                    }
                    value={addBasemix.alias}
                  />
                  {/* <span className="danger-color">
                        {nameError && nameError}
                      </span> */}
                </Col>
                <Col xl={24} className="select-categories" style={{ margin: "10px" }}>
                  <label style={{ color: "#26a69a", fontSize: "16px" }}>
                    Categories <span className="color-orange">*</span>
                  </label>
                  <Select
                    placeholder="categories"
                    name="basemix_category_id"
                    onChange={(e) => {
                      setAddBasemix({
                        ...addBasemix,
                        basemix_category_id: e,
                      });
                      setBasemixErr({
                        ...basemixError,
                        basemix_category_idError: "",
                      });
                    }}
                  >
                    {basemixData.map((categoryName, index) => {
                      return (
                        <Option key={categoryName.id} value={categoryName.id}>
                          {categoryName.name}
                        </Option>
                      );
                    })}
                  </Select>
                  <Row justify="start">
                    <Col>
                      <span className="danger-color text-left">
                        {basemixError.basemix_category_idError &&
                          basemixError.basemix_category_idError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col xl={24}>
                  {/* <TextInput
                    label="Basemix Description"
                    name="description"
                    onChange={(description) =>
                      setAddBasemix({
                        ...addBasemix,
                        description: description.target.value,
                      })
                    }
                    required
                    value={addBasemix.description}
                  /> */}
                  <TextField
                    label="Basemix Description"
                    name="description"
                    multiline
                    rows={4}
                    variant="standard"
                    InputLabelProps={{
                      style: { color: "#26a69a" },
                    }}
                    sx={{
                      "& .MuiFormLabel-asterisk.MuiInputLabel-asterisk": {
                        color: "orange",
                      },
                    }}
                    onChange={(description) =>
                      setAddBasemix({
                        ...addBasemix,
                        description: description.target.value,
                      })
                    }
                    value={addBasemix.description}
                    fullWidth={true}
                  />
                </Col>
              </Row>
            </Col>
          </CustomModal>
          <CustomModal
            visible={isAdditiveModal}
            onCancelModal={() => setIsAdditiveModal(false)}
            footer={[
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={addAdditiveHandler}
              >
                Save
              </Button>,
            ]}
          >
            <Col xl={24}>
              <h5 className="text-left ">New Additive</h5>
              <Divider />
            </Col>
            <Col xl={24} className="pointer-cursor">
              <Row justify="center" gutter={[20, 0]}>
                <Col xl={12}>
                  <TextInput
                    label="Additive Name "
                    name="name"
                    onChange={(name) => {
                      setAddAdditive({
                        ...addAdditive,
                        name: name.target.value,
                      });
                      setAdditiveError({
                        ...additiveError,
                        nameError: "",
                      });
                    }}
                    required
                    value={addAdditive.name}
                  />
                  {/* <span className="danger-color">
                        {nameError && nameError}
                      </span> */}
                  <Row justify="start">
                    <Col>
                      <span className="danger-color text-left">
                        {additiveError.nameError && additiveError.nameError}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col xl={12}>
                  <TextInput
                    label="Additive Alias"
                    name="alias"
                    onChange={(alias) =>
                      setAddAdditive({
                        ...addAdditive,
                        alias: alias.target.value,
                      })
                    }
                    value={addAdditive.alias}
                  />
                  {/* <span className="danger-color">
                        {nameError && nameError}
                      </span> */}
                </Col>
                <Col xl={24}>
                  <TextInput
                    style={{ maxHeight: "8rem" }}
                    label="Additive Description"
                    name="description"
                    onChange={(description) =>
                      setAddAdditive({
                        ...addAdditive,
                        description: description.target.value,
                      })
                    }
                    value={addAdditive.description}
                  />
                </Col>
              </Row>
            </Col>
          </CustomModal>
        </Col>
      </Row>
      <input
        onChange={(e) => {
          var reader = new FileReader();
          reader.readAsDataURL(e.target.files[0]);
          reader.onload = function () {
            setImageUrl(reader.result);
          };
          setCustomProduct({
            ...customProduct,
            image: e.target.files[0],
          });
        }}
        className="d-none"
        ref={(ref) => (inputRef = ref)}
        type="file"
      />
    </CardWrapper>
  );
}
export default General_Info;
